import type { FilterKey, OptionalFilter } from '@library/types/filters';
import type { ComboboxOption } from '@library/components/selects';
import { useState } from 'react';

export function useLeagueDependentFilters<T extends OptionalFilter>({
  defaultFilters
}: {
  defaultFilters: T;
}): {
  changeFilterValue: (
    filterKey: FilterKey,
    value: string | Array<string> | Array<ComboboxOption>
  ) => void;
  changeFilterValues: (
    batchFilters: Partial<
      Record<FilterKey, string | Array<string> | Array<ComboboxOption>>
    >
  ) => void;
  filters: T;
  setFilters: (filters: T) => void;
} {
  const [filters, setFilters] = useState(defaultFilters);

  const changeFilterValues = (
    batchFilters: Partial<
      Record<FilterKey, string | Array<string> | Array<ComboboxOption>>
    >
  ) => {
    const newFilterState = {
      ...defaultFilters,
      ...batchFilters
    };
    setFilters(newFilterState);
  };

  const changeFilterValue = (
    filterKey: FilterKey,
    value: string | Array<string> | Array<ComboboxOption>
  ) => {
    const newFilterState = {
      ...filters,
      [filterKey]: value
    };

    setFilters(newFilterState);
  };

  return {
    changeFilterValue,
    changeFilterValues,
    filters,
    setFilters
  };
}
